import { ComponentPropsWithoutRef } from 'react';
import { useSubscriptionPlans } from './useSubscriptionPlans';
import { twMerge } from 'tailwind-merge';
import { GivebutterPlusPlan } from 'types/domain';

interface PlanRowLabelProps {
    row: GivebutterPlusPlan;
    currentPlanId: string | undefined;
}
const PlanRowLabel = ({ row, currentPlanId }: PlanRowLabelProps) => {
    const { data: plans } = useSubscriptionPlans();

    const currentPlan = plans.find(plan => plan.id === currentPlanId);
    const rowPlan = plans.find(plan => plan.id === row.id);

    const rowIsDowngrade =
        rowPlan && currentPlan && rowPlan.contacts_max < currentPlan.contacts_max;

    if (row.id === currentPlanId) {
        return (
            <div className="absolute left-0 top-0 z-10 bg-gray-200 px-1 py-0.5 text-[0.625rem] font-medium leading-[0.625rem]">
                Current plan
                <div className="absolute right-[-7px] top-0">
                    <div className="h-0 w-0 border-b-[7px] border-l-[7px] border-t-[7px] border-b-transparent border-l-gray-200 border-t-transparent"></div>
                </div>
            </div>
        );
    }
    if (row.is_recommend && !rowIsDowngrade) {
        return (
            <div className="absolute left-0 top-0 z-10">
                <RecommendedArrow />
            </div>
        );
    }
    return null;
};

interface RecommendedArrowProps extends ComponentPropsWithoutRef<'div'> {}
const RecommendedArrow = ({ className, ...rest }: RecommendedArrowProps) => {
    return (
        <div
            className={twMerge(
                'bg-brand-butter-primary relative w-fit px-1 py-0.5 text-[0.625rem] font-medium leading-[0.625rem]',
                className,
            )}
            {...rest}
        >
            Recommended
            <div className="absolute right-[-7px] top-0">
                <div className="border-l-brand-butter-primary h-0 w-0 border-b-[7px] border-l-[7px] border-t-[7px] border-b-transparent border-t-transparent"></div>
            </div>
        </div>
    );
};

export { PlanRowLabel, RecommendedArrow };
export type { PlanRowLabelProps };
